import React from 'react';

const JournalDate = () => {
    return (
        <p className="date"><span className="large">04</span> July, 2023</p>
    );
};

export default JournalDate;
